import { useMemo } from "react";
import type { BoardDragModel } from "./boardDragState";

/** What render-time drag state resolves against: the current props. */
export const useBoardDragModel = <TItem>({
    cells,
    cellOrder,
    compareItems,
    getMovedItem,
    canPlaceBetween,
    canPlaceAt,
    canMove,
}: BoardDragModel<TItem>) =>
    useMemo(
        (): BoardDragModel<TItem> => ({
            cells,
            cellOrder,
            compareItems,
            getMovedItem,
            canPlaceBetween,
            canPlaceAt,
            canMove,
        }),
        [
            cells,
            cellOrder,
            compareItems,
            getMovedItem,
            canPlaceBetween,
            canPlaceAt,
            canMove,
        ],
    );
